// @flow

import type {AccountXRayData} from 'docs/data';
import type {AccountXRayRequestModel} from 'docs/types';

export const transformAccountXRay = (
  model: AccountXRayRequestModel,
): AccountXRayData => ({
  username: model.username,
});
